module.exports = __webpack_public_path__ + "img/stop-16.ed95f95a.jpg";